import UploadIcon from 'assets/images/form/inputUploadPlusIcon.svg?react';
import cn from 'classnames';
import { FormikErrors, FormikTouched } from 'formik';
import React, { Ref, RefObject } from 'react';
import InputError from 'shared/components/form/inputError';
import './styles.scss';

interface InputUploadProps {
	name: string;
	label: string;
	values: any;
	isFieldValueValid: (field: string, errors: any, touched: {}) => boolean;
	setFieldValue: (field: string, val: any) => void;
	ref: RefObject<HTMLInputElement>;
	openUploader: (ref: Ref<HTMLInputElement>) => void;
	errors: FormikErrors<{ [field: string]: any }>;
	touched: FormikTouched<any>;
	setFieldTouched: (name: string, bool: boolean) => void;
	cyTestRef?: string;
	cyErrorRef?: string;
}

const InputUpload = React.forwardRef(function Transition(
	{
		name,
		values,
		label,
		isFieldValueValid,
		errors,
		touched,
		setFieldValue,
		setFieldTouched,
		openUploader,
		cyTestRef,
		cyErrorRef,
	}: InputUploadProps & { children?: React.ReactElement<any, any> },
	ref: React.Ref<HTMLInputElement>,
) {
	const isError = isFieldValueValid('uploadFront', errors, touched);

	return (
		<div className="inputUpload">
			<div
				className={cn(
					'inputUpload__container',
					{ 'inputUpload__container--withValue': values[name].name },
					{ 'inputUpload__container--error': isError },
				)}
			>
				<input
					type="file"
					accept="image/*"
					name={name}
					ref={ref}
					onChange={(e: any) => {
						const data = e.target.files[0];
						setFieldTouched(name, true);
						setFieldValue(name, data || '');
					}}
					data-cy={cyTestRef}
				/>
				<div className="inputUpload__text">
					<label className={`inputUpload__label ${values[name].name && 'inputUpload__label--up'}`}>{label}</label>
					<span>{values[name].name && values[name].name}</span>
				</div>
				<UploadIcon className="inputUpload__icon" />
			</div>
			<InputError isError={isError} name={name} errors={errors} cyErrorRef={cyErrorRef} />
		</div>
	);
});

export default InputUpload;
